import { useContext } from 'react'
import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import ToggleListItem from '@components/ToggleListItem'

const handleUpdateBrandGroup = (params) => {
  const {
    entityState, updateBrandGroup, updateFn,
  } = params

  updateBrandGroup({
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Brand Group Updated',
  })
}

const BrandGroupSettings = (props) => {
  const { brandGroupFormPayload, brandGroupPayload } = props

  const {
    callbacks: {
      updateBrandGroup: updateFn,
    },
  } = brandGroupPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: { updateBrandGroup },
  } = pageContext

  const {
    entityState: {
      full_access,
      agency_paginated,
      debug_mode,
      disable_agency_sharing,
    },
  } = brandGroupFormPayload

  return (
    <DashboardModule title="Settings">
      <Form padding="large" boxProps={{ paddingBottom: 'medium' }}>
        <ToggleListItem
          onClick={() => handleUpdateBrandGroup({
            entityState: { full_access: !full_access }, updateBrandGroup, updateFn,
          })}
          toggleValue={full_access}
        >
          <ToggleListItem.Title>Full Access</ToggleListItem.Title>
          <ToggleListItem.Description>
            Lead group admin agency has full access to all other agencies within group
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => handleUpdateBrandGroup({
            entityState: { agency_paginated: !agency_paginated }, updateBrandGroup, updateFn,
          })}
          toggleValue={agency_paginated}
        >
          <ToggleListItem.Title>Agency Paginated</ToggleListItem.Title>
          <ToggleListItem.Description>
            The agency will paginate it&#39;s own publications
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => handleUpdateBrandGroup({
            entityState: { debug_mode: !debug_mode }, updateBrandGroup, updateFn,
          })}
          toggleValue={debug_mode}
        >
          <ToggleListItem.Title>Debug Mode</ToggleListItem.Title>
          <ToggleListItem.Description>
            Print debug messages when auto&#8211;paginated
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => handleUpdateBrandGroup({
            entityState: { disable_agency_sharing: !disable_agency_sharing }, updateBrandGroup, updateFn,
          })}
          toggleValue={disable_agency_sharing}
        >
          <ToggleListItem.Title>Disable Agency Sharing</ToggleListItem.Title>
          <ToggleListItem.Description>
            Agencies won&#39;t be able to share within brand group
          </ToggleListItem.Description>
        </ToggleListItem>
      </Form>
    </DashboardModule>
  )
}

BrandGroupSettings.propTypes = {
  brandGroupFormPayload: PropTypes.object.isRequired,
  brandGroupPayload: PropTypes.object.isRequired,
}

export default BrandGroupSettings
